import { Adressvorschlag, ADRESSVORSCHLAG_FAILED_REASON } from '@ps20-frontend/frontend-models';
import {
  AdressvorschlagFailedPayload,
  AdressvorschlagPayload,
  CALLER_ID,
  GlobalActions,
} from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { VwgActions } from '../vwgActions';
import { IAppState } from '../appState';

export const adressvorschlagReducer = function (
  sectionState: Adressvorschlag = null,
  action: AnyAction,
  appState: IAppState,
): Adressvorschlag {
  switch (action.type) {
    case GlobalActions.ADDRESSVORSCHLAG_SUCCESSFUL: {
      const payload: AdressvorschlagPayload = action.payload;
      const angebotsId = appState.angebotsId;
      const callerId = `${CALLER_ID.VWG_BASISDATEN}_${angebotsId}`;
      if (payload.callerId !== callerId) {
        return sectionState;
      }
      return {
        lastError: null,
        orte: payload.orte,
        strassen: payload.strassen,
      };
    }

    case GlobalActions.ADDRESSVORSCHLAG_FAILED: {
      const payload: AdressvorschlagFailedPayload = action.payload;
      const angebotsId = appState.angebotsId;
      const callerId = `${CALLER_ID.VWG_BASISDATEN}_${angebotsId}`;
      if (payload.callerId !== callerId) {
        return sectionState;
      }
      return {
        lastError: payload.reason,
        orte: [],
        strassen: [],
      };
    }

    case VwgActions.PLZ_CHANGED: {
      return {
        lastError:
          action.payload.plz.length === 5 ? null : ADRESSVORSCHLAG_FAILED_REASON.PLZ_INVALID,
        orte: [],
        strassen: [],
      };
    }

    default:
      return sectionState;
  }
};
